import { createActions } from 'redux-actions';
import { InsurancePolicyItemList } from '@models/InsurancePolicyItem';

export type State = {
  policyItems?: InsurancePolicyItemList[] | null;
}

export type StateUpdatePayload = Partial<State>;

export const {
  insurancePolicyItemsFetch,
  stateUpdate,
} = createActions(
  'INSURANCE_POLICY_ITEMS_FETCH',
  'STATE_UPDATE',
  {
    prefix: 'DASHBOARD_PAGE',
  },
);
